export default "__VITE_ASSET__CZG8IQxb__"